import { Stack, Typography } from "@mui/material";
import { Product } from "../../types/Product";
import { WorkshopProduct } from "../../types/WorkshopProducts";

export const TestingStartPageHeader = ({ product, workshopProduct }:
    { product?: Product, workshopProduct?: WorkshopProduct } ) => {
    const headerStr = `${product?.name ?? ""} ${workshopProduct?.productVersion ?? ""}`;

    return <Stack direction={'row'} justifyContent={'space-between'}>
        <Typography variant='h4'>{headerStr}</Typography>
    </Stack>
}